import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';

class ListFilterCompany extends React.Component {
  listItemFormatter = client => `${client.profile.company || '?'}`;

  listItemId = client => {
    return client.username;
  };

  render() {
    const {
      intl: { messages },
      paramName,
      updateLocation,
      onUpdate,
      saveRef,
    } = this.props;

    return (
      <ListFilterAsyncMultiple
        title={messages.company}
        listName="clients"
        listUrl="/api/clients.json"
        listUrlData={{
          filters: { type: 'company', isDeleted: false},
        }}
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        paramName={paramName}
        updateLocation={updateLocation}
        onUpdate={onUpdate}
        saveRef={saveRef}
      />
    );
  }
}
ListFilterCompany.defaultProps = {
  paramName: 'target',
  saveRef: () => {},
};

export default injectIntl(ListFilterCompany);
